import React from 'react'
import { SuggestedFacetButton } from '../filter-button/suggested-facet-button'
import { useForm } from '../../forms/hocs/form.context'

export const FacetSuggestionPills = () => {
    const { suggestedFacets } = useForm()

    return (
        <>
            {suggestedFacets?.map(({ title, facetGroupName }) => {
                return <SuggestedFacetButton key={title} text={title} facetGroupName={facetGroupName} />
            })}
        </>
    )
}
